import { companyTypesEnum } from 'constants/companyTypes';

export const isBrand = () => {
  const type = localStorage.getItem('type');
  let isTypeBrand = type === companyTypesEnum.BRAND;
  return {
    isTypeBrand,
  };
};
